export default "__VITE_ASSET__I2p_8o5z__"